import React, { Component } from 'react';
import { Colours } from '../Common/Colours';

let inputStyleNorm = {
	fontFamily: 'Myriad-light',
	border: 0,
	marginTop: 30,
	background: 'none',
	borderBottom: '1px solid rgba(117, 117, 117, 0.42)',
	minWidth: 100,
	outline: 'none',
	width: '100%',
};

let inputStyleError = {
	fontFamily: 'Myriad-light',
	border: 0,
	marginTop: 30,
	background: 'none',
	borderBottom: '1px solid red',
	minWidth: 100,
	outline: 'none',
	width: '100%',
};

let inputStyleMouseOver = {
	fontFamily: 'Myriad-light',
	border: 0,
	marginTop: 29,
	background: 'none',
	borderBottom: '2px solid rgb(1, 82, 118)',
	transform: 'scaleX(1)',
	minWidth: 100,
	outline: 'none',
	width: '100%',
}

let inputStyleOnClick = {
	fontFamily: 'Myriad-light',
	border: 0,
	marginTop: 29,
	background: 'none',
	borderBottom: '2px solid rgb(1, 82, 118)',
	transform: 'scaleX(1)',
	minWidth: 100,
	outline: 'none',
	width: '100%',
	fontSize: 26,
	padding: 0,
};

let labelStyleNorm = {
	fontFamily: 'Myriad-light',
	top: 0,
	left: 0,
	position: 'absolute',
	lineHeight: 1,
	transform: 'translate(0, 24px) scale(1)',
	transition: 'transform 0.5s',
	cursor: 'text',
	color: '#757575',
	fontSize: 18,
	transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
}

let labelStyleOnClick = {
	fontFamily: 'Myriad-light',
	top: 0,
	left: 0,
	position: 'absolute',
	transition: 'transform 0.5s',
	transform: 'translate(0, 0) scale(0.85)',
	transformOrigin: 'top left',
	color: window.app != null ? window.app.state.colours.editbox_placeholder : Colours.light.editbox_placeholder,
	transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
}

let labelStyleError = {
	fontFamily: 'Myriad-light',
	top: 0,
	left: 0,
	position: 'absolute',
	transition: 'transform 0.5s',
	transform: 'translate(0, 0) scale(0.85)',
	transformOrigin: 'top left',
	color: 'red',
	transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
}

class Editbox extends Component {
	constructor(props) {
		super(props);
		this.state = {
			placeholder: this.props.placeholder,
			labelStyle: (this.props.value != null && this.props.value != '') ? labelStyleOnClick : labelStyleNorm,
			inputStyle: (this.props.value != null && this.props.value != '') ? inputStyleOnClick : inputStyleNorm,
			error: false,
			value: '',
		};
	};

	componentDidMount() {
		let input = document.getElementById('input_' + this.props.id);
		if (input != null) {
			input.addEventListener('keypress', (e) => {
				this.handleOnChange(e);
			}, false);
		}
	}

	componentWillMount() {
		if (this.props.error) {
			this.setState({
				labelStyle: labelStyleError,
				inputStyle: inputStyleError,
				error: true,
			});
		} else {
			var colors = {};

			if (this.props.fontColor != null) {
				colors.color = this.props.fontColor;
			}
			if (this.props.lineColor != null) {
				colors.borderColor = this.props.lineColor;
				colors.borderBottom = "1px solid " + this.props.lineColor;
			}

			let inputBoxStyle = Object.assign(JSON.parse(JSON.stringify(this.state.inputStyle)), colors)
			this.setState(() => {
				return { inputStyle: inputBoxStyle, }
			})
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (nextProps.value != nextState.value && nextProps.value != undefined) {
			this.setState({
				value: nextProps.value
			})

			if (nextProps.value != null && nextProps.value != '') {
				this.setState({
					labelStyle: labelStyleOnClick,
					inputStyle: inputStyleOnClick,
				});
			} else {
				this.setState({
					labelStyle: labelStyleNorm,
					inputStyle: inputStyleNorm,
				})

				if (this.props.placeholder2 != null) {
					this.setState({
						placeholder: this.props.placeholder
					})
				}
			}
		}

		if (nextProps.placeholder != this.state.placeholder) {
			this.setState({
				placeholder: nextProps.placeholder
			})
		}

		return true;
	}

	handleOnFocus = () => {
		if (this.props.read_only) {
			return;
		}

		if (!this.state.error) {
			this.setState({
				labelStyle: labelStyleOnClick,
				inputStyle: inputStyleOnClick,
			});
			if (this.props.onClick != null) {
				this.props.onClick();
			}
		}

		if (this.props.placeholder2 != null) {
			this.setState({
				placeholder: this.props.placeholder2,
			})
		}

		if (this.props.onFocus != null) this.props.onFocus();
	}

	handleOnBlur = (colors) => {
		if (this.state.value == '' || this.state.value == undefined) {
			this.setState({
				labelStyle: labelStyleNorm,
				inputStyle: { ...inputStyleNorm, ...colors },
				placeholder: this.props.placeholder,
			})
		}

		if (this.state.error) {
			this.setState({
				labelStyle: labelStyleError,
				inputStyle: inputStyleError,
			});
		}

		if (this.props.onBlur != null) this.props.onBlur();
	}

	handleOnMouseOver = () => {
		if (this.state.value == '') {
			this.setState(() => {
				return { inputStyle: inputStyleMouseOver, }
			})
		}
	}

	handleOnMouseLeave = (colors) => {
		var newStyle = Object.assign(JSON.parse(JSON.stringify(inputStyleNorm)), colors)
		if (this.state.value == '') {
			this.setState({
				inputStyle: newStyle,
			}, () => {
				return;
			})
		}

		if (this.state.error) {
			this.setState({
				inputStyle: inputStyleError,
			});
		}
	}

	handleOnChange = (event) => {
		if (this.props.inputType === "number") {
			if (event.target.value.length > 10) {
				return;
			}
		}

		// Cannot be more than 50 chars
		if (event.target.value.length > 50) {
			return;
		}

		this.props.onChange(event);
		this.setState({
			value: event.target.value,
		});
		if (event.target.value != '' && event.target.value != null) {
			this.setState({
				labelStyle: labelStyleOnClick,
				inputStyle: inputStyleOnClick,
			});
		}
		if (this.props.placeholder2 != null) {
			this.setState({
				placeholder: this.props.placeholder2,
			})
		}
	};

	render() {
		var colors = {};

		let style = {

		}

		if (this.props.fontColor != null) {
			colors.color = this.props.fontColor;
		}
		if (this.props.lineColor != null) {
			colors.borderColor = this.props.lineColor;
			colors.borderBottom = "1px solid " + this.props.lineColor;
		}

		style = Object.assign(style, this.props.style);
		let labelStyle = Object.assign({ ...this.state.labelStyle }, { ...this.props.labelStyle });
		let inputStyle = Object.assign({ ...this.state.inputStyle }, { ...this.props.inputStyle });

		return (
			<div style={style} >
				<div style={{ position: 'relative' }}>
					<label id='placeholder' style={labelStyle} onClick={this.handleOnFocus}>{this.state.placeholder} </label>
				</div>
				<input
					id={'input_' + this.props.id}
					type={this.props.inputType}
					style={inputStyle}
					onChange={(event) => this.handleOnChange(event)}
					onFocus={this.handleOnFocus}
					onBlur={() => this.handleOnBlur(colors)}
					onMouseOver={this.handleOnMouseOver}
					onMouseLeave={() => this.handleOnMouseLeave(colors)}
					value={this.props.value != null ? this.props.value : undefined}
					min={this.props.min}
					step={this.props.step}
					readOnly={this.props.read_only}
				/>
			</div>
		);
	}
}

export default Editbox;